import { server_error_message, server_error_title } from "../utilities/values";
import serverError from "../assets/serverError.png";
import { CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

function ErrorComponent({ onRetry, isLoading }) {
  return (
    <div className="text-center py-3 px-16">
      <img src={serverError} alt="server error" className="block m-auto w-28 my-4" />
      <p className="font-bold text-lg">{server_error_title}</p>
      <p className="text-gray-500">{server_error_message}</p>
      <Button
        className={`w-full mt-3 text-white ${
          isLoading ? "bg-[#F6F7F7]" : "bg-[#0947AB]"
        }`}
        onClick={onRetry}
        disabled={isLoading}
      >
        {isLoading ? <CircularProgress size={"1rem"} /> : "Retry"}
      </Button>
    </div>
  );
}

ErrorComponent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onRetry: PropTypes.func.isRequired
};

export default ErrorComponent;
